document.addEventListener("DOMContentLoaded", () => {
  const layers = document.getElementById("depth");
  const sqftInput = document.getElementById("sqft");
  const sizeInput = document.getElementById("stoneSize");
  const errorDiv = document.getElementById("error");
  const totalWeightInput = document.getElementById("totalWeight");
  const bagsNeededInput = document.getElementById("bagsNeeded");
  const palletsNeededInput = document.getElementById("palletsNeeded");
  const calculateBtn = document.querySelector(".calculator-button");

  const calculateValues = () => {
    const sqft = parseFloat(sqftInput.value) || 0;
    const stonelayer = parseFloat(layers.value) || 0;
    const size = parseFloat(sizeInput.value) || 0;

    const bagWeight = [5.5, 7.5, 11.5].includes(size)
      ? 50
      : [10, 14, 21].includes(size)
      ? 75
      : 0;
    const bagsPerPallet = [5.5, 7.5, 11.5].includes(size)
      ? 49
      : [10, 14, 21].includes(size)
      ? 40
      : 0;

    const totalWeight = sqft * (size * stonelayer);
    let bagsNeeded = Math.ceil(totalWeight / bagWeight);
    let pallets = Math.ceil((totalWeight / bagWeight / bagsPerPallet) * 2) / 2;

    if (
      isNaN(pallets) ||
      isNaN(bagsNeeded) ||
      isNaN(totalWeight) ||
      totalWeight === 0
    ) {
      errorDiv.textContent = "Please fill out all inputs";
      totalWeightInput.value = "";
      bagsNeededInput.value = "";
      palletsNeededInput.value = "";
    } else {
      errorDiv.textContent = "";
      totalWeightInput.value = totalWeight;
      bagsNeededInput.value = bagsNeeded;
      palletsNeededInput.value = pallets;
    }
  };

  [sqftInput, layers, sizeInput].forEach((input) => {
    input.addEventListener("change", calculateValues);
  });

  calculateBtn.addEventListener("click", (event) => {
    event.preventDefault();
    calculateValues();
  });
});
